import _ from 'underscore';

class GroupSettingData {
  constructor(data: $TSFixMe) {
    Object.assign(this, _(data).pick('definition', 'typeName'));
  }

  get value() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'definition' does not exist on type 'Grou... Remove this comment to see the full error message
    return this.definition.value;
  }

  toJSON() {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    return _(this).pick('definition', 'typeName');
  }
}

export default GroupSettingData;
